import type { Money } from '@web-platform/shared-universal-constants/src/money';
import type { Values } from '@web-platform/shared-universal-types-utils/src/utils';

export const PRICE_RANGE_INDICATOR = {
  HIGHER: 'HIGHER',
  LOWER: 'LOWER',
  EXPECTED: 'EXPECTED',
} as const;

export type PriceRangeIndicator = Values<typeof PRICE_RANGE_INDICATOR>;

export type PriceBandsProps = {
  pOutlierLow: Money;
  pLow: Money;
  pHigh: Money;
  pOutlierHigh: Money;
  percentileValueLow: number;
  percentileValueHigh: number;
  priceMarker: Money;
  priceRangeIndicator: PriceRangeIndicator;
  priceDifference: Money;
  priceMarkerPercentage: number;
};

export type PriceBandsData = {
  isLoading: boolean;
  isError: boolean;
  priceBands: PriceBandsProps | null;
};

export type RelativePercentageType = Omit<
  PriceBandsProps,
  'priceRangeIndicator' | 'priceDifference' | 'priceMarkerPercentage'
>;
